import React from "react";
import { useMediaQuery, useTheme } from "@mui/material";

import DesktopDetailSection from "./DesktopDetailSection";
import MobileDetailSection from "./MobileDetailSection";

const DetailSection: React.FC<{
  course: NSCourses.ICourseDetailProps;
}> = ({ course }) => {
  const theme = useTheme();
  const isDownMD = useMediaQuery(theme.breakpoints.down("md"));
  return (
    <>
      {isDownMD ? (
        <MobileDetailSection course={course} />
      ) : (
        <DesktopDetailSection course={course} />
      )}
    </>
  );
};

export default DetailSection;
